import {initMainHeader} from '../js/src/header-init';
import {replaceLAZoneAbbrNow, loadCSS} from "../js/src/utils";
import {getQuoteFormInit} from "../js/src/get-quote-form";

initMainHeader();
getQuoteFormInit();
initRfqModal();
replaceLAZoneAbbrNow();

loadCSS('build/assets/css/font-awesome.css');

import '../scss/pages/pdf.scss';

function initRfqModal() {
    const openBtn = document.getElementById('open-rfq-modal');
    const modalContainer = document.getElementById('rfq-modal');

    openBtn.addEventListener('click', e => {
        if (modalContainer.className.indexOf('opened') !== -1) {
            closeForm();
        } else {
            openForm()
        }
        e.preventDefault();
    });

    modalContainer.addEventListener('click', e => {
        if (e.target === modalContainer || e.target.className.indexOf('btn-close-modal') !== -1) {
            closeForm();
        }
    });

    function openForm() {
        modalContainer.style.display = 'flex';
        setTimeout(() => modalContainer.classList.add('opened'), 10);

    }
    function closeForm() {
        modalContainer.classList.remove('opened');
        setTimeout(() => modalContainer.style.display = 'none', 500);
    }
}

